<template>
  <div class="ugm-loading-overlay">
    <div class="ugm-loading-card">
      <div class="ugm-loading-header">
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
          <circle cx="18" cy="18" r="16" stroke="rgba(255,255,255,0.3)" stroke-width="3"/>
          <path d="M18 2 A16 16 0 0 1 34 18" stroke="white" stroke-width="3" stroke-linecap="round" class="ugm-spin-arc"/>
        </svg>
      </div>
      <div class="ugm-loading-body">
        <p class="ugm-loading-title">{{ hasProgress ? 'Cargando asistentes' : 'Cargando' }}</p>
        <p class="ugm-loading-sub">
          {{ (progress && progress.mensaje) || 'Esto podría tardar unos segundos.' }}
        </p>
        <template v-if="hasProgress">
          <div class="ugm-progress-track" role="progressbar" :aria-valuenow="progressPercent" aria-valuemin="0" aria-valuemax="100">
            <div class="ugm-progress-bar" :style="{ width: progressPercent + '%' }">
              {{ progressPercent }}%
            </div>
          </div>
          <p class="ugm-progress-count">
            {{ progress.procesados || 0 }}<template v-if="Number(progress.total) > 0"> de {{ progress.total }}</template> filas procesadas
          </p>
          <p v-if="progress.fila_actual" class="ugm-progress-current">
            {{ progress.fila_actual }}
          </p>
        </template>
        <div v-else class="ugm-dots">
          <span></span><span></span><span></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingMessage',
  props: {
    progress: {
      type: Object,
      default: null,
    },
  },
  computed: {
    hasProgress() {
      return !!this.progress;
    },
    progressPercent() {
      const value = Number(this.progress && this.progress.porcentaje);
      return Math.max(0, Math.min(100, Number.isFinite(value) ? Math.round(value) : 0));
    },
  },
};
</script>

<style scoped>
.ugm-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(37, 44, 95, 0.55);
  backdrop-filter: blur(3px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.ugm-loading-card {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(37, 44, 95, 0.25);
  min-width: 240px;
  text-align: center;
}

.ugm-loading-header {
  background: linear-gradient(135deg, #252C5F 0%, #61B7E4 100%);
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.ugm-spin-arc {
  transform-origin: 18px 18px;
  animation: ugm-spin 0.9s linear infinite;
}

@keyframes ugm-spin {
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
}

.ugm-loading-body {
  padding: 20px 32px 24px;
}

.ugm-loading-title {
  margin: 0 0 4px;
  font-size: 1rem;
  font-weight: 700;
  color: #252C5F;
}

.ugm-loading-sub {
  margin: 0 0 14px;
  font-size: .82rem;
  color: #6c757d;
}

.ugm-progress-track {
  width: 100%;
  height: 12px;
  margin: 16px 0 8px;
  overflow: hidden;
  border-radius: 999px;
  background: #e9eef5;
}

.ugm-progress-bar {
  height: 100%;
  min-width: 2px;
  border-radius: inherit;
  background: linear-gradient(90deg, #252C5F 0%, #61B7E4 100%);
  color: #fff;
  font-size: .68rem;
  font-weight: 700;
  line-height: 12px;
  text-align: center;
  transition: width .25s ease;
}

.ugm-progress-count,
.ugm-progress-current {
  margin: 0;
  color: #6c757d;
  font-size: .75rem;
}

.ugm-progress-current {
  overflow: hidden;
  margin-top: 4px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ugm-dots {
  display: flex;
  justify-content: center;
  gap: 6px;
}

.ugm-dots span {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #61B7E4;
  animation: ugm-bounce 1.2s infinite ease-in-out;
}

.ugm-dots span:nth-child(1) { animation-delay: 0s;    background: #252C5F; }
.ugm-dots span:nth-child(2) { animation-delay: 0.2s;  background: #61B7E4; }
.ugm-dots span:nth-child(3) { animation-delay: 0.4s;  background: #CB9700; }

@keyframes ugm-bounce {
  0%, 80%, 100% { transform: scale(0.6); opacity: .5; }
  40%           { transform: scale(1);   opacity: 1;  }
}
</style>